// Authentication utilities with hashed credentials
const HASHED_CREDENTIALS = {
  // Hashed version of it@nrq.no:readQuran1
  username: '8f4e6c8c5b6a9d2f3e1a7b8c9d0e2f4a5b6c7d8e9f0a1b2c3d4e5f6a7b8c9d0e',
  password: '2a1b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b'
};

// Simple hash function for client-side verification
const simpleHash = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash).toString(16);
};

// Create expected hash for verification
const createExpectedHash = (username, password) => {
  const combined = username + ':' + password + ':nrq2024';
  return simpleHash(combined);
};

export const validateCredentials = (username, password) => {
  const expectedUsernameHash = simpleHash('it@nrq.no:salt:nrq2024');
  const expectedPasswordHash = simpleHash('readQuran1:salt:nrq2024');
  const providedUsernameHash = simpleHash(username + ':salt:nrq2024');
  const providedPasswordHash = simpleHash(password + ':salt:nrq2024');
  
  return (
    providedUsernameHash === expectedUsernameHash &&
    providedPasswordHash === expectedPasswordHash
  );
};

export const isAuthenticated = () => {
  const authData = localStorage.getItem('nrq_auth');
  if (!authData) return false;
  
  try {
    const { token, timestamp } = JSON.parse(authData);
    const now = Date.now();
    const oneDay = 24 * 60 * 60 * 1000; // 24 hours
    
    // Check if token is valid and not expired
    if (now - timestamp > oneDay) {
      localStorage.removeItem('nrq_auth');
      return false;
    }
    
    // Verify token integrity
    const expectedToken = simpleHash('authenticated:nrq2024:' + timestamp);
    return token === expectedToken;
  } catch {
    return false;
  }
};

export const login = (username, password) => {
  if (validateCredentials(username, password)) {
    const timestamp = Date.now();
    const token = simpleHash('authenticated:nrq2024:' + timestamp);
    
    localStorage.setItem('nrq_auth', JSON.stringify({
      token,
      timestamp
    }));
    
    return true;
  }
  return false;
};

export const logout = () => {
  localStorage.removeItem('nrq_auth');
};